import React from "react";
import { Navbar, NavbarBrand } from "shards-react";
import logo from '../../assets/images/logo.svg';

class SidebarMainNavbar extends React.Component {

    render() {
        return (
            <div className="main-navbar">
                <Navbar
                    className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
                    type="light"
                >
                    <NavbarBrand
                        className="w-100 mr-0"
                        to="/dashboard"
                        style={{ lineHeight: "25px" }}
                    >
                        <div className="d-table m-auto">
                            <img
                                id="main-logo"
                                style={{ maxWidth: "135px", marginTop: "-5px" }}
                                src={logo}
                                alt="Hellocare Dashboard"
                            />
                        </div>
                    </NavbarBrand>
                    <a
                        className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
                    >
                        <i className="material-icons">&#xE5C4;</i>
                    </a>
                </Navbar>
            </div>
        );
    }
}

export default SidebarMainNavbar;



// WEBPACK FOOTER //
// ./src/layouts/MainSidebar/SidebarMainNavbar.js